import { Controller } from "@hotwired/stimulus"

/**
 * Quiz Editor Controller
 * Handles adding/removing questions and options in the quiz wizard
 */
export default class extends Controller {
  static targets = ["form", "questionsContainer", "questionsList", "questionTemplate"]

  questionIndex = 0

  connect() {
    // Initialize index based on existing questions
    const existingCards = this.questionsListTarget.querySelectorAll(".question-card")
    this.questionIndex = existingCards.length
  }

  addQuestion(event) {
    event.preventDefault()

    const template = this.questionTemplateTarget.innerHTML
    const newQuestion = template
      .replace(/INDEX/g, this.questionIndex.toString())
      .replace(/QNUM/g, (this.questionIndex + 1).toString())

    const tempDiv = document.createElement("div")
    tempDiv.innerHTML = newQuestion
    const questionCard = tempDiv.firstElementChild

    this.questionsListTarget.appendChild(questionCard)
    this.questionIndex++

    // Focus the question text field
    const textarea = questionCard.querySelector("textarea")
    if (textarea) textarea.focus()
  }

  removeQuestion(event) {
    event.preventDefault()

    const card = event.target.closest(".question-card")
    if (!card) return

    // Don't allow removing the last question
    const allCards = this.questionsListTarget.querySelectorAll(".question-card")
    if (allCards.length <= 1) {
      alert("Quiz must have at least one question")
      return
    }

    card.remove()
    this.renumberQuestions()
  }

  renumberQuestions() {
    const cards = this.questionsListTarget.querySelectorAll(".question-card")
    cards.forEach((card, index) => {
      // Update the visible question number
      const numberSpan = card.querySelector("[data-quiz-editor-target='questionNumber']")
      if (numberSpan) {
        numberSpan.textContent = (index + 1).toString()
      }
    })
  }

  toggleImageSource(event) {
    const card = event.target.closest(".question-card")
    if (!card) return

    const urlField = card.querySelector("[data-quiz-editor-target='imageUrlField']")
    if (!urlField) return

    if (event.target.value === "upload") {
      urlField.classList.remove("hidden")
    } else {
      urlField.classList.add("hidden")
    }
  }
}
